import api from "./axios";

export async function getSubjects(filters = {}) {
  const { name, description, parentId, pageNo = 1, pageSize = 20 } = filters;

  const params = {};

  if (name && name.trim().length > 0) {
    params.name = name.trim();
  }

  if (description && description.trim().length > 0) {
    params.description = description.trim();
  }

  if (parentId !== undefined && parentId !== null && parentId !== "") {
    params.parentId = parentId;
  }

  params.pageNo = pageNo;
  params.pageSize = pageSize;

  const res = await api.get("/subjects", { params });

  return res.data;
}

export async function getSubjectsWithQuestionCount() {
    const res = await api.get(`/subjects/question-counts`);
    return res.data;
}

export async function getParentSubjects() {
    const res = await api.get(`/subjects/parents`);
    return res.data;
}

export async function getSubjectById(id) {
  const res = await api.get(`/subjects/${id}`);
  return res.data;
}

export async function createSubject(payload) {
  const res = await api.post("/subjects", payload);
  return res.data;
}

export async function updateSubject(payload) {
  const res = await api.put("/subjects", payload);
  return res.data;
}

export async function deleteSubject(id) {
  const res = await api.delete(`/subjects/${id}`);
  return res.data;
}

export async function assignStudentsToSubject(subjectId, studentNumbers) {
  const body = {
    subjectId: Number(subjectId),
    studentNumbers: studentNumbers || [],
  };

  const res = await api.post("/subjects/students", body);
  return res.data;
}
